import dayjs from 'dayjs'
import React from 'react'
import { Cell } from '../../../store/types'
import DateFormat from '../../../store/types/enums/DateFormat'
import { StyledTableCell, StyledTableRow } from '../../../styles/TableStyles'

type ScheduleTableRowProps = {
  cells: Cell[]
  isTogglable?: boolean
  toggleContent?: React.ReactNode
  onClick?: (e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLTableRowElement>) => void
  onDoubleClick?: (e: React.MouseEvent<HTMLElement>) => void
  isSelected?: boolean
  isOpen?: boolean
  isWeekday: boolean
  isEditable?: boolean
  date: string
}

const ScheduleTableRow = ({
  cells,
  isTogglable = false,
  toggleContent,
  onClick,
  onDoubleClick,
  isWeekday,
  isSelected,
  isEditable,
  date,
}: ScheduleTableRowProps) => {
  const handleClick = (e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLTableRowElement>) => {
    if (onClick) onClick(e)
  }

  const handleDoubleClick = (e: React.MouseEvent<HTMLElement>) => {
    if (onDoubleClick) onDoubleClick(e)
  }

  return (
    <StyledTableRow
      className={`${isSelected ? 'selected' : ''} ${!isWeekday ? 'weekend' : ''}`}
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          handleClick(e)
        }
      }}
      isTogglable={isTogglable}
      sx={{
        height: '32px',
        '&:hover': {
          cursor: isTogglable ? 'pointer' : 'default',
        },
        '&:hover .dropdown-icon': {
          opacity: 1,
          visibility: isEditable ? 'hidden' : 'visible',
        },
        ':focus .dropdown-icon': {
          opacity: 1,
          visibility: isEditable ? 'hidden' : 'visible',
        },
        '.dropdown-error-icon': {
          opacity: isEditable ? 0 : 1,
          visibility: isEditable ? 'hidden' : 'visible',
        },
      }}
      tabIndex={isTogglable ? 0 : -1}
    >
      <StyledTableCell className="left">{dayjs(date).format(DateFormat.DayNumberDayName)}</StyledTableCell>
      {cells?.map((c, i) => (
        <StyledTableCell key={c.id} align={c.align} className={`${i === cells.length - 1 && 'right'}`}>
          {c.value}
        </StyledTableCell>
      ))}
    </StyledTableRow>
  )
}

export default ScheduleTableRow
